import React from 'react';
import image1 from '../assets/image1.png'
import image2 from '../assets/image2.png'
import image3 from '../assets/image3.png'

const Features = () => {
  return (
    <div className="bg-[#F8E8D9] p-10">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 md:-mt-32">
        {/* Card 1 */}
        <div className="bg-[#E6B17E] p-6 rounded-3xl lg:w-[320px]  text-center  flex flex-col justify-between ">
          <div className="mb-4 flex justify-center items-center">
            {/* Replace this with an icon */}
            <img src={image1} alt='' className='w-20 h-20'/>
          </div>
          <h3 className="text-2xl font-semibold font-montserrat text-[#551E19]">Premium Quality</h3>
          <p className='text-white text-lg font-montserrat'>We source only the finest materials for your pets.</p>
        </div>

        {/* Card 2 */}
        <div className="bg-[#E6B17E] p-6 rounded-3xl lg:w-[320px]  text-center flex flex-col justify-between">
          <div className="mb-4 flex justify-center items-center">
            {/* Replace this with an icon */}
            <img src={image2} alt='' className='w-20 h-20'/>
          </div>
          <h3 className="text-2xl font-semibold font-montserrat text-[#551E19]">Eco-Friendly Products</h3>
          <p className='text-white text-lg font-montserrat'>Safe for your pets and the planet.</p>
        </div>

        {/* Card 3 */}
        <div className="bg-[#E6B17E] p-6 rounded-3xl lg:w-[320px]  text-center flex flex-col justify-between">
          <div className="mb-4 flex justify-center items-center">
            {/* Replace this with an icon */}
            <img src={image3} alt='' className='w-20 h-20'/>
          </div>
          <h3 className="text-2xl font-semibold font-montserrat text-[#551E19]">Fast & safe Shipping</h3>
          <p className='text-white text-lg font-montserrat'>All products deliver fast and safely to your doorstep.</p>
        </div>
      </div>
    </div>
  );
};

export default Features;
